import { css } from '@/styled-system/css';

export const tourLightboxContent = css({
  bg: 'rgba(42, 42, 51, 0.92)',
});

export const tourLightboxHeader = css({
  '& header': {
    bg: 'rgba(42, 42, 51, 1)',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'rgba(255, 255, 255, 0.1)',
  },
});

export const tourLightboxContainer = css({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  md: {
    padding: '4x',
  },
});

export const tourLightboxIframe = css({
  width: '100%',
  height: '100%',
  border: 'none',
  borderRadius: 0,
  md: {
    borderRadius: '8px',
  },
});
